import { render, staticRenderFns } from "./smart-suite.vue?vue&type=template&id=53ad47e3"
import script from "./smart-suite.vue?vue&type=script&lang=js"
export * from "./smart-suite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports